module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isEnhanced) ? _c('div', {
    staticClass: "e_view"
  }, [_c('div', {
    staticClass: "right_panel"
  }, [_c('ul', {
    staticClass: "tabs"
  }, [_c('li', {
    class: {
      active: _vm.isActive('article-detail')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail')
      }
    }
  }, [_vm._v("Article")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('article-detail-authors')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail-authors')
      }
    }
  }, [_vm._v("Authors")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('article-detail-related')
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navigateTo('article-detail-related')
      }
    }
  }, [_vm._v("Related")])])]), _vm._v(" "), _vm._t("anchors"), _vm._v(" "), _vm._t("keywords"), _vm._v(" "), _vm._t("authors"), _vm._v(" "), _vm._t("current_article")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("title"), _vm._v(" "), _vm._t("full_text"), _vm._v(" "), _vm._t("default")], 2)]) : _c('div', {
    staticClass: "d_view"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._t("bar")], 2)]), _vm._v(" "), _c('ul', {
    staticClass: "tabs hidden-sm-down"
  }, [_vm._l((_vm.options), function(option) {
    return _c('li', {
      class: {
        active: _vm.isActive(option.value)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.navigateTo(option.value)
        }
      }
    }, [_vm._v(_vm._s(option.text))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toggleToEnhanced
    }
  }, [_vm._v("Enhanced View")])])], 2), _vm._v(" "), _c('b-form-select', {
    staticClass: "hidden-md-up",
    attrs: {
      "options": _vm.options
    },
    on: {
      "input": function($event) {
        _vm.navigateTo(_vm.selected)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-3 hidden-sm-down"
  }, [_c('div', {
    staticClass: "articleAnchors",
    attrs: {
      "id": "articleAnchors"
    }
  }, [_vm._t("anchors")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-9 article-content"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.handleResize
    }
  }), _vm._v(" "), _vm._t("full_text")], 2)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "navModal",
      "title": "Jump To",
      "hide-footer": true
    }
  }, [_c('div', {
    staticClass: "anchors"
  }, _vm._l((_vm.modalAnchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.$route.hash == ('#' + key) || (key == 'Abstract' && !_vm.$route.hash)
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])])
  }))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4d588a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/ArticleDetailComponent.vue
// module id = 1477
// module chunks = 1